export default "__VITE_ASSET__C36P9EHr__"